export default {
  ENGLISH: 'en',
  FRENCH: 'fr',
  SPANISH: 'es',
};
